module.exports = __webpack_public_path__ + "static/media/calendar.ae49672f.svg";